import { PushNotification } from '../models';

export class SetPushNotification {
  static readonly type = '[PUSHNOTIFICATION] Set';

  constructor(public payload) {}
}
